/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { LikeDto } from '../../models/like-dto';

export interface LikeControllerFindByPickId$Params {
  pickId: string;
}

export function likeControllerFindByPickId(http: HttpClient, rootUrl: string, params: LikeControllerFindByPickId$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<LikeDto>>> {
  const rb = new RequestBuilder(rootUrl, likeControllerFindByPickId.PATH, 'get');
  if (params) {
    rb.path('pickId', params.pickId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<LikeDto>>;
    })
  );
}

likeControllerFindByPickId.PATH = '/api/like/pick/{pickId}';
